import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import CmdType from 'src/service/constants';
import {TermsApiResponse, TermsApiResponseUiData} from 'src/types/type';
import { ServerUrl, getImageServerPath } from 'src/utils/APIPath';
import { defaultUiStyle } from 'src/utils/UiStyle';
import { modifyUiData } from "src/service/join";
import { convertTermsData } from 'src/service/join/index';
import { addApiBreadcrumb } from 'src/utils/sentry/breadcrumb';
import { captureServerError, captureUnexpectedErrCode } from 'src/utils/sentry/api';
import { captureTermsListError } from 'src/utils/sentry/validation';
import { ERR_CODES } from 'src/types/errcode';

export const useTermsQuery = (requestID: string, data: any) => {

  const httpData = {
    Header: {
      CmdType: CmdType.getterms,
      CallApp: "mkt01",
      RequestID: requestID,
    },
    Body: data,
  };

  return useQuery([CmdType.getterms, data], async () => {
    addApiBreadcrumb('request', { cmdType: CmdType.getterms });

    return await axios
      .post(ServerUrl, JSON.stringify(httpData), {
        withCredentials: true,
      })
      .then((response): TermsApiResponse | null => {
        const { Header, Body } = response.data;
        if (Header.ErrCode !== ERR_CODES.SUCCESS) {
          addApiBreadcrumb('response', {
            cmdType: CmdType.getterms,
            errCode: Header.ErrCode,
            errMsg: Header.ErrMsg,
          });
          captureUnexpectedErrCode(Header);
          alert(Header.ErrMsg);
          return null;
        } else {
          const convertedTerms = convertTermsData(Body);
          captureTermsListError(convertedTerms);
          return {
            Terms: convertedTerms,
            Partner: {
              ...Body.Partner,
              Image1: getImageServerPath(Body.Partner?.Image1),
              Image2: getImageServerPath(Body.Partner?.Image2),
              UiData: !!Body.Partner.UiData ?
                  modifyUiData(JSON.parse(atob(Body.Partner.UiData)) as TermsApiResponseUiData) :
                  defaultUiStyle,
            },
          };
        }
      })
      .catch((error) => {
        captureServerError(error, CmdType.getterms);
        throw error;
      });
  }, { refetchOnWindowFocus: false });
};
